<template>
  <div :class="`headerDepartment${file.departmentId}`" v-if="file">
    <div style="float: right; text-align: right" v-if="department">
      <div :class="`department${file.departmentId}`">{{ department.name }}</div>
      <slot />
    </div>
    <div>
      <FileZ :file="file" />
    </div>
    <div>
      <strong v-if="category">{{ category.shortname }}</strong>
      <span>&#160;</span>
      <span v-if="subjectProperty">{{ subjectProperty.name }}</span>
    </div>
    <div v-if="clients">
      <div v-for="client in clients" :key="client.id">
        <EntityZ :entity="client" />
      </div>
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import FileZ from "@/components/link/FileZ";
import EntityZ from "@/components/link/EntityZ";
function initialState() {
  return {
    file: null,
    department: null,
    category: null,
    clients: null,
    subjectProperty: null
  };
}
export default {
  name: "Matter",
  props: ["fileid"],
  components: { EntityZ, FileZ },
  data: function () {
    return initialState();
  },
  methods: {
    fetchFile() {
      nbmlaw.get(`/cors/admin/file/files/${this.fileid}`).then((response) => {
        // console.log(response.data);
        this.file = response.data;
      });
    },
    fetchDepartment() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.fileid}/department`)
        .then((response) => {
          // console.log(response.data);
          this.department = response.data;
        });
    },
    fetchCategory() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.fileid}/category`)
        .then((response) => {
          // console.log(response.data);
          this.category = response.data;
        });
    },
    fetchClients() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.fileid}/clients/false`)
        .then((response) => {
          // console.log(response.data);
          this.clients = response.data;
        });
    },
    fetchSubjectProperty() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.fileid}/subjectProperty`)
        .then((response) => {
          // console.log(response.data);
          this.subjectProperty = response.data;
        });
    },
    update() {
      this.fetchFile();
      this.fetchDepartment();
      this.fetchCategory();
      this.fetchClients();
      this.fetchSubjectProperty();
    }
  },
  watch: {
    fileid: {
      immediate: true,
      handler() {
        if (this.fileid) {
          this.update();
        } else {
          Object.assign(this.$data, initialState());
        }
      }
    },
    file: {
      handler() {
        this.$emit("loaded", this.file ? true : false);
        this.$emit("loadedFile", this.file);
      }
    },
    clients: {
      handler() {
        this.$emit("loadedClients", this.clients);
      }
    }
  }
};
</script>